import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import React__default, { forwardRef } from 'react';
import { Icon } from '../../display/Icon/Icon.es.js';
import { Spinner } from '../../display/Spinner/Spinner.es.js';
import { TextInput } from '../TextInput/TextInput.es.js';
import { camelCaseAriaAttrs } from '../../../utils/formatAriaAttrKeys.es.js';

const clearSelectionButton = "_clear-selection-button_ag3gl_1";
const styles = {
	clearSelectionButton: clearSelectionButton
};

const ClearSelectionButton = ({ clearSelection }) => {
  return React__default.createElement(
    "button",
    { className: styles.clearSelectionButton, type: "button", onClick: clearSelection, title: "Clear Selection", "data-zds": true },
    React__default.createElement(Icon, { canAcceptPointerEvents: false, name: "formXCircle", size: 20 })
  );
};
const InputIcon = (props) => {
  return props.renderIcon && props.selectedItem ? props.renderIcon(props.selectedItem, props.getLabelForItem) : (
    // Search icon also handles the use case where an item has been
    // selected but props.renderIcon has not been specified.
    React__default.createElement(Icon, { name: "navSearch", size: props.iconSize })
  );
};
const TypeaheadInput = forwardRef((_a, ref) => {
  var { size = "medium" } = _a, props = __rest(_a, ["size"]);
  const showClearSelectionButton = props.selectedItem && !props.isDisabled;
  return React__default.createElement(
    TextInput,
    Object.assign({}, camelCaseAriaAttrs(props.getInputProps({
      // @ts-ignore this is valid, but downshift TS types are wrong
      ariaLabelledBy: props.ariaLabelledBy,
      autoComplete: props.autoComplete,
      onFocus: props.onFocus,
      onKeyDown: props.onKeyDown
    })), { "aria-label": props["aria-label"], autoComplete: "off", canClickIconAfter: showClearSelectionButton, disabledText: props.disabledText, isDisabled: props.isDisabled, isErrored: props.isErrored, placeholder: props.placeholder, onBlur: props.onBlur, ref, renderIconAfter: ({ iconSize, isFocused, isHovered }) => showClearSelectionButton ? React__default.createElement(ClearSelectionButton, { clearSelection: props.clearSelection, isFocused, isHovered }) : props.iconEndName && React__default.createElement(Icon, { name: props.iconEndName, size: iconSize }), renderIconBefore: ({ iconSize }) => {
      if (props.isBusy) {
        return React__default.createElement(
          "span",
          { style: { width: iconSize }, "data-zds": true },
          React__default.createElement(Spinner, null)
        );
      }
      return React__default.createElement(InputIcon, Object.assign({}, props, { iconSize }));
    }, size })
  );
});

export { TypeaheadInput };
//# sourceMappingURL=TypeaheadInput.es.js.map
